import { errors, locales } from "@ept/shared/src/errors";

export const byteValueNumberFormatter = Intl.NumberFormat("en", {
  notation: "compact",
  style: "unit",
  unit: "byte",
  unitDisplay: "narrow",
});

export const errorFormatter = (errorKey?: string) => {
  let userLanguage = localStorage.getItem("language") || "RO";

  if (!locales.includes(userLanguage as (typeof locales)[number])) {
    userLanguage = "RO";
  }

  const userLanguageGood = userLanguage as (typeof locales)[number];

  if (!errorKey) {
    return errors["general.internal_error"][userLanguageGood];
  }
  return errors[errorKey as keyof typeof errors]?.[userLanguageGood] || errorKey;
};
